import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface WarningIconProps extends SvgIconProps {
  fillColor?: string;
}

const WarningIcon = ({ fillColor = '#FF9800', ...props }: WarningIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        d="M8 3.99325L13.02 12.6666H2.98L8 3.99325ZM8 1.33325L0.666672 13.9999H15.3333L8 1.33325ZM8.66667 10.6666H7.33334V11.9999H8.66667V10.6666ZM8.66667 6.66659H7.33334V9.33325H8.66667V6.66659Z"
        fill={fillColor}
      />
    </SvgIcon>
  );
};

export default WarningIcon;
